import {Badge, Button, Drawer, HStack, Icon, Portal, Text, VStack} from "@chakra-ui/react"
import {IoCloseSharp} from "react-icons/io5"
import {useEffect, useState} from "react"
import JsonMappingForm, {extractFields} from "@/pages/workers/components/JsonMappingForm"

const WorkerMappingModal = ({isOpen, onClose, onSave, worker, initialMappings = {}}) => {
    const [mappings, setMappings] = useState({})
    const [fields, setFields] = useState([])

    useEffect(() => {
        if (!worker || !isOpen) return
        setMappings(initialMappings)
        try {
            setFields(worker.jsonSchema ? extractFields(JSON.parse(worker.jsonSchema)) : [])
        } catch {
            setFields([])
        }
    }, [worker, isOpen])

    const handleSave = () => {
        onSave?.(worker.id, mappings)
        onClose()
    }

    return (
        <Drawer.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()} size={'md'} placement={'end'}>
            <Portal>
                <Drawer.Backdrop/>
                <Drawer.Positioner padding="4">
                    <Drawer.Content bg={"bg.drawer"} borderRadius={16}>
                        <Drawer.Header>
                            <HStack justifyContent={'space-between'} w={'full'}>
                                <VStack alignItems={'flex-start'} gap={0}>
                                    <HStack>
                                        <Text color={'white'} fontWeight={'semibold'}>{worker?.name}</Text>
                                        <Badge colorPalette={'green'} size={'sm'}>${worker?.tag}</Badge>
                                    </HStack>
                                    <Text color={'gray.400'} fontSize={13}>Override field mappings</Text>
                                </VStack>
                                <Icon fontSize={32} color={'text.grey'} onClick={onClose} cursor={'pointer'}>
                                    <IoCloseSharp/>
                                </Icon>
                            </HStack>
                        </Drawer.Header>
                        <Drawer.Body>
                            {fields.length > 0 ? (
                                <JsonMappingForm
                                    fields={fields}
                                    readOnly={false}
                                    mappings={mappings}
                                    onChange={(path, val) => setMappings(prev => ({...prev, [path]: val}))}
                                />
                            ) : (
                                <Text color={'gray.500'}>This worker has no JSON schema defined.</Text>
                            )}
                        </Drawer.Body>
                        <Drawer.Footer borderRadius={16}>
                            <HStack justifyContent={'flex-end'} w={'full'} gap={3}>
                                <Button variant="outlined" textDecoration='unset' onClick={onClose}>Cancel</Button>
                                <Button variant="primary" textDecoration='unset' onClick={handleSave}>Save</Button>
                            </HStack>
                        </Drawer.Footer>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    )
}

export default WorkerMappingModal
